import { ComponentProps } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { AnimatePresence, motion } from 'framer-motion';
import { uniqueId } from 'lodash';

import config from '@/config';
import Toast from '@/components/common/Toast';

interface ToastData extends Omit<ComponentProps<typeof Toast>, 'onDismiss'> {
  id: string;
}

const toastsVar = makeVar<ToastData[]>([]);

export const addToast = ({ id, ...data }: ToastData & { id?: string }) => {
  if (id == null && config('/debug')) {
    console.error('Each toast should have an ID, otherwise it is given a random one');
  }
  const toast = { ...data, id: id ?? uniqueId('toast-') };
  return toastsVar([...toastsVar().filter((x) => x.id !== toast.id), toast]);
};

export const removeToast = (id: string) => toastsVar(toastsVar().filter((x) => x.id !== id));

const ToastList = () => {
  const toasts = useReactiveVar(toastsVar);

  return (
    <div className="pointer-events-none fixed z-50 inset-0 flex flex-col justify-end md:items-end p-4 md:p-6">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="pointer-events-auto w-full sm:max-w-md relative z-0 mt-2"
            layout
          >
            <Toast onDismiss={() => removeToast(toast.id)} {...toast} />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastList;
